<div class="exam active" [class.active]="active" [class]="theme">
	<figure>
		<img [src]="image" [alt]="title" [title]="title" />
	</figure>
	<p>{{ title }}</p>
</div>
